import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["width", "height"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as React from 'react';
import IconBase from '../icons/IconBase';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var NewLogoSquare = function NewLogoSquare(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 48 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 48 : _ref$height,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(IconBase, _objectSpread(_objectSpread({
    viewBox: "0 0 320 320"
  }, props), {}, {
    $styles: _objectSpread({
      width: width,
      height: height
    }, (props === null || props === void 0 ? void 0 : props.$styles) || {}),
    children: [/*#__PURE__*/_jsx("path", {
      d: "M0 80C0 35.8172 35.8172 0 80 0H240C284.183 0 320 35.8172 320 80V240C320 284.183 284.183 320 240 320H80C35.8172 320 0 284.183 0 240V80Z",
      fill: "#FFDD33"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M211.878 61H182.902L207.049 103.425L153.927 61H124.951L151.512 112.854L95.9756 61H67L95.9756 127.004L67 259H95.9756L151.512 117.575L124.951 259H153.927L207.049 108.146L182.902 259H211.878L265 93.996L211.878 61Z",
      fill: "#1C1C1E"
    })]
  }));
};

export default NewLogoSquare;